import { useEffect } from 'react';
import { useDebouncedCallback } from 'use-debounce';

export default function useWindowResize(onCallback: () => void) {
  const debounced = useDebouncedCallback(() => {
    onCallback();
  }, 500);

  useEffect(() => {
    window.addEventListener('resize', debounced);

    return () => {
      window.removeEventListener('resize', debounced);
    };
  }, [debounced]);
}
